import classNames from 'classnames';
import styles from "../Variants.module.js";
export function getVariantClasses(variant = 'PRIMARY', error = false) {
  return classNames({
    [styles.primary]: variant === 'PRIMARY',
    [styles.secondary]: variant === 'SECONDARY',
    [styles.tertiary]: variant === 'TERTIARY',
    [styles.process]: variant === 'PROCESS',
    [styles.error]: !!error
  });
}